import {httpGet,httpPut,httpDelete,httpPost} from '../../../util/request.js';
import appConfig from '../../../config';

export default class UserApi{

    static QUERY_USER_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/users";
    static GET_USER_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/user";
    static PERSIST_USER_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/user";

    static STOP_USER_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/user/stop";
    static RESTORE_USER_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/org/user/restore";
	
	static queryUser(params){
		return httpGet(UserApi.QUERY_USER_API_URL,params);
    }
    
    static getUser(params){
		return httpGet(UserApi.GET_USER_API_URL,params);
    }
    
    //保存人员信息
	static persistUser(user){
		let params={user:user};
		return httpPost(UserApi.PERSIST_USER_API_URL,params);
    }
    
    static stopUser(user){
		let params={user:user};
		return httpPost(UserApi.STOP_USER_API_URL,params);
    }
    
    static restoreUser(user){
		let params={user:user};
		return httpPost(UserApi.RESTORE_USER_API_URL,params);
	}
	
}
